import { render, staticRenderFns } from "./BookingTaxi.vue?vue&type=template&id=4692830e&scoped=true"
import script from "./BookingTaxi.vue?vue&type=script&lang=js"
export * from "./BookingTaxi.vue?vue&type=script&lang=js"
import style0 from "./BookingTaxi.vue?vue&type=style&index=0&id=4692830e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4692830e",
  null
  
)

export default component.exports